// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  // apiUrl: 'https://api.bmiinstitute.com/api',
  apiUrl: 'https://devbmiapi.techprostudio.com/api',
  // baseUrl: 'https://student.bmiinstitute.com',
  baseUrl: 'https://devbmistudent.techprostudio.com',
  // authApiUrl: 'https://api.bmiinstitute.com/api/bmi-students',
  authApiUrl: 'https://devbmiapi.techprostudio.com/api/bmi-students',
  // basePath: 'https://api.bmiinstitute.com'
  basePath: 'https://devbmiapi.techprostudio.com',
};



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/environments/environment.ts